import { BarChartProps } from '@mui/x-charts/BarChart/BarChart';
import { BarChart as MuiBarChart } from '@mui/x-charts/BarChart';
import * as React from 'react';

interface Props extends BarChartProps {
    readonly styled: StyledProps;
}

export class BarChart extends React.PureComponent<Props> {
    render() {
        const { themeMode } = this.props.styled;
        return (
            <MuiBarChart
                {...this.props}
                sx={{
                    '& .MuiChartsAxis-root': {
                        fill: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                    },
                    '& .MuiChartsAxis-tickLabel': {
                        fill: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                    },
                    '& .MuiChartsAxis-line': {
                        stroke: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                    },
                    '& .MuiChartsAxis-tick': {
                        stroke: themeMode === 'light' ? '#1a73e8 !important' : '#6ba5ff !important',
                    },
                    ...this.props.sx,
                }}
            />
        );
    }
}